export default "<div class=\"row\">\n\t<ion-icon *ngFor=\"let tag of tags\" src=\"/assets/perfectday/{{ tag.identifier }}.svg\"></ion-icon>\n</div>\n";